import { useRef } from "react";
import { Html } from "@react-three/drei";
import linkIcon from "../../static/images/link.png";

function EmbedLinkSpot({
 embedLinkSpot,
 selectObject,
 transformControl,
 isPreviewComponent,
}) {
 const mesh = useRef(null);

 const onClickHandler = (event) => {
    if (!isPreviewComponent) {
      let linkValue = embedLinkSpot.link;
      let hrefValue;
      if (linkValue.startsWith("http://") || linkValue.startsWith("https://")) {
        hrefValue = linkValue;
      } else {
        hrefValue = `https://${linkValue}`;
      }
      window.open(hrefValue, "_blank");
    } else {
      selectObject(embedLinkSpot, mesh.current);
    }
 };

 console.log("Link: ", embedLinkSpot);

 return (
    <mesh ref={mesh} position={embedLinkSpot.position}>
      <Html center zIndexRange={[100, 10]}>
        <img
          src={linkIcon}
          className="infoTextspot"
          alt="information text"
          width="35px"
          height="35px"
          onClick={(e) => {
            onClickHandler();
          }}
        />
      </Html>
    </mesh>
 );
}

export default EmbedLinkSpot;